import * as types from './actionTypes'

const INITIAL_STATE = JSON.parse(JSON.stringify({
  urlPagamento: {
    isLoading: false,
  },
  executePagamento: {
    isLoading: false,
  },
  saveRememberCard: {
    isLoading: false,
  },
  saveComprovantePagamento: {
    isLoading: false,
  },
  pagarmePixTransaction: {
    isLoading: false,
  },
  pagarmeCaptureTransaction: {
    isLoading: false,
  },
}))

export default (state = INITIAL_STATE, action) => {
  switch(action.type) {
    case types.REQUEST_URL_PAGAMENTO:
    case types.RECEIVE_URL_PAGAMENTO:
      return {
        ...state,
        urlPagamento: {
          isLoading: action.isLoading,
        }
      }
    case types.REQUEST_EXECUTE_PAGAMENTO:
    case types.RECEIVE_EXECUTE_PAGAMENTO:
      return {
        ...state,
        executePagamento: {
          isLoading: action.isLoading,
        }
      }
    case types.REQUEST_SAVE_PAYPAL_REMEMBER_CARD:
    case types.RECEIVE_SAVE_PAYPAL_REMEMBER_CARD:
      return {
        ...state,
        saveRememberCard: {
          isLoading: action.isLoading,
        }
      }
    case types.REQUEST_SAVE_COMPROVANTE_PAGAMENTO:
    case types.RECEIVE_SAVE_COMPROVANTE_PAGAMENTO:
      return {
        ...state,
        saveComprovantePagamento: {
          isLoading: action.isLoading,
        }
      }
    case types.REQUEST_PAGARME_PIX_TRANSACTION:
    case types.RECEIVE_PAGARME_PIX_TRANSACTION:
      return {
        ...state,
        pagarmePixTransaction: {
          isLoading: action.isLoading,
        }
      }
    case types.REQUEST_PAGARME_CAPTURE_TRANSACTION:
    case types.RECEIVE_PAGARME_CAPTURE_TRANSACTION:
      return {
        ...state,
        pagarmeCaptureTransaction: {
          isLoading: action.isLoading,
        }
      }
    default:
      return state
  }
}
